// extracted by mini-css-extract-plugin
module.exports = {"icon":"ColorSelect_icon__3s8IF"};